var _rect, _rect2, _mask, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIStopAudio = function SvgIStopAudio(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 42,
    height: 42,
    rx: 12,
    fill: "#EA2E4E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 78,
    height: 78,
    rx: 39,
    stroke: "white",
    strokeWidth: 4
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_5119_30168",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 41C82 35.6158 80.9395 30.2843 78.8791 25.31C76.8186 20.3356 73.7986 15.8158 69.9914 12.0086C66.1842 8.20142 61.6644 5.18138 56.69 3.12094C51.7157 1.0605 46.3842 -2.35351e-07 41 0V4.17417C45.836 4.17417 50.6247 5.1267 55.0926 6.97737C59.5606 8.82804 63.6202 11.5406 67.0398 14.9602C70.4594 18.3798 73.172 22.4394 75.0226 26.9074C76.8733 31.3753 77.8258 36.164 77.8258 41H82Z",
    stroke: "#EA2E4E",
    strokeWidth: 8,
    strokeLinejoin: "round",
    mask: "url(#path-4-inside-1_5119_30168)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIStopAudio);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/i-stop-audio.dc484f9bd93a65c2409751789edc0c4f.svg";